import React from "react";
import css from "../../css/find-agent/container.module.css";
import PropTypes from "prop-types";

const BG_CLASS = {
    white: css.containerWhite,
};

class Container extends React.PureComponent {
    render() {
        const { title, link, background } = this.props;
        let containerClassName = null;

        if (background) {
            containerClassName = BG_CLASS[background];
        } else {
            containerClassName = css.container;
        }

        return (
            <div className={containerClassName}>
                <div className={css.wrapper}>
                    <div className={css.header}>
                        <h2 className={css.title}>{title}</h2>
                        {link && <div className={css.titleLink}>{link}</div>}
                    </div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

Container.propTypes = {
    title: PropTypes.object.isRequired,
    link: PropTypes.object,
    background: PropTypes.string,
};

export default Container;
